<script setup lang="ts">
import { tv } from "tailwind-variants"

const { variant = "filled", passive = false, size = "md" } = defineProps<{
  variant?: "filled" | "outline"
  passive?: boolean
  size?: "sm" | "md"
}>()

const cls = tv({
  variants: {
    variant: {
      filled: "bg-[--theme-medium] text-white",
      outline: "bg-transparent shadow-[inset_0_0_0_2px_var(--theme-light)] text-white",
    },
    passive: {
      true: "",
      false: "",
    },
    size: {
      sm: "text-base leading-[20px] px-1.5 pb-0.5",
      md: "text-sm/[18px] md:text-xl/[24px] px-2 pb-[3px] md:pb-0.5",
    },
  },
  compoundVariants: [
    {
      variant: "filled",
      passive: true,
      class: "bg-[--theme-translucent-light]",
    },
    {
      variant: "outline",
      passive: true,
      class: "!shadow-[inset_0_0_0_2px_var(--theme-medium)] !text-[--theme-medium]",
    },
  ],
})
</script>

<template>
  <span
    class="gap-2 h-fit w-fit font-national2 font-bold italic inline-flex rounded-md"
    :class="cls({ variant, passive, size })"
  >
    <slot />
  </span>
</template>
